import { motion } from "framer-motion";
import { Target, Eye, BadgeCheck, HeartHandshake, Wallet } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const CARDS = [
  {
    num: "04",
    icon: Eye,
    label: "Our Vision",
    text: "To become Kerala's most trusted and preferred deep cleaning service provider, creating healthier, cleaner and happier spaces for every home and business.",
  },
  {
    num: "05",
    icon: Target,
    label: "Our Mission",
    text: "To provide reliable, professional and affordable deep cleaning services with sincerity and attention to detail, using trained professionals and quality cleaning methods to make every space fresh, hygienic and dust-free.",
  },
];

const VALUES = [
  { icon: BadgeCheck, label: "Trustworthy" },
  { icon: HeartHandshake, label: "Reliable" },
  { icon: Wallet, label: "Budget-Friendly" },
];

export default function MissionVision() {
  return (
    <section
      id="mission"
      className="relative py-24 lg:py-36 bg-gradient-to-b from-[#EFF8E8]/70 to-[#FAFCFA] overflow-hidden"
      data-testid="mission-section"
    >
      <div className="absolute -top-32 right-0 w-[460px] h-[460px] rounded-full bg-[radial-gradient(circle,rgba(108,190,69,0.14),transparent_65%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 relative">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="font-mono-accent text-xs font-semibold uppercase tracking-[0.28em] text-[#4A8F2A] mb-5 text-center"
        >
          Vision & Mission
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.85, delay: 0.1, ease: EASE }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08] text-center max-w-3xl mx-auto"
        >
          Why{" "}
          <span className="font-serif-accent italic font-semibold text-[#4A8F2A]">
            Team PK
          </span>{" "}
          exists
        </motion.h2>

        <div className="mt-16 grid md:grid-cols-2 gap-6 lg:gap-10 max-w-5xl mx-auto">
          {CARDS.map((c, i) => (
            <motion.article
              key={c.label}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, delay: i * 0.14, ease: EASE }}
              className="group relative rounded-2xl bg-white border border-[#6CBE45]/20 p-9 hover:-translate-y-1.5 hover:border-[#D4AF37]/60 hover:shadow-[0_24px_60px_-18px_rgba(74,143,42,0.3)] transition-[transform,border-color,box-shadow] duration-500"
              data-testid={`mission-card-${i + 1}`}
            >
              <span className="absolute top-6 right-7 font-mono-accent text-sm font-semibold text-[#D4AF37]">
                {c.num}
              </span>
              <span className="w-12 h-12 rounded-xl bg-[#EFF8E8] group-hover:bg-[#FDFBF2] flex items-center justify-center transition-colors duration-500">
                <c.icon className="w-6 h-6 text-[#6CBE45] group-hover:text-[#D4AF37] transition-colors duration-500" />
              </span>
              <h3 className="mt-6 text-xl sm:text-2xl font-semibold tracking-tight text-[#4A8F2A]">
                {c.label}
              </h3>
              <p className="mt-3 text-sm sm:text-base text-[#4A5A5E] leading-relaxed">
                {c.text}
              </p>
            </motion.article>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="mt-12 flex flex-wrap justify-center gap-4"
          data-testid="mission-values"
        >
          {VALUES.map((v) => (
            <span
              key={v.label}
              className="inline-flex items-center gap-2.5 rounded-full border border-[#6CBE45]/30 bg-white px-5 py-2.5 text-sm font-semibold text-[#4A8F2A]"
            >
              <v.icon className="w-4 h-4 text-[#D4AF37]" />
              {v.label}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
